import { throttledResetToLogin } from 'common/api';
import { STATUS_HTTPS, TYPE_OF_ANT_DESIGN } from 'common/constant';
import { createClient, fetchExchange, mapExchange } from 'urql';

import showMessage from '../components/Message';

let apiToken = '';
export const getTokenAppSync = (token: any): any => {
  apiToken = process.env.REACT_APP_ENV !== 'local' ? token : process.env.REACT_APP_APPSYNC_API_KEY;
};

export const client = createClient({
  url: `${process.env.REACT_APP_APPSYNC_URL}`,
  suspense: true,
  fetchOptions: () => {
    return {
      headers: {
        Authorization: apiToken,
        'X-Api-Key': apiToken,
      },
    };
  },
  exchanges: [
    mapExchange({
      onError(error, operation) {
        console.log(
          `The operation ${operation.key} has errored with:`,
          `response status: ${error?.response?.status}`,
          error
        );
        if (error?.response?.status === STATUS_HTTPS.UNAUTHENTICATED) {
          throttledResetToLogin();
        } else {
          return showMessage(TYPE_OF_ANT_DESIGN.ERROR, 'message.common.0003');
        }
      },
    }),
    fetchExchange,
  ],
});

export default { client, getTokenAppSync };
